import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../../../components/tailwind/button";
import { Card, CardContent } from "../../../../../components/tailwind/card";

export function WorkflowAnalyticsInsightsCard({ message, workflowId, version }) {
  const navigate = useNavigate();

  return (
    <Card className="border-indigo-200 dark:border-indigo-900/60 bg-indigo-50 dark:bg-indigo-950/40 shadow-sm">
      <CardContent className="p-4 flex flex-col sm:flex-row sm:items-center gap-3">
        <div className="flex items-start gap-2.5 min-w-0 flex-1">
          <Sparkles className="h-4 w-4 text-indigo-600 dark:text-indigo-300 shrink-0 mt-0.5" />
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wide text-indigo-700 dark:text-indigo-300">
              Insight
            </p>
            <p className="text-sm text-indigo-900 dark:text-indigo-100 leading-snug mt-0.5">
              {message}
            </p>
          </div>
        </div>
        <Button
          type="button"
          size="sm"
          className="shrink-0 self-start sm:self-center bg-indigo-600 hover:bg-indigo-500 dark:bg-indigo-500 dark:hover:bg-indigo-400 text-white"
          onClick={() =>
            navigate(`/whatsapp/workflows/${workflowId}/edit`, {
              state: { version: Number(version) }
            })
          }
        >
          Edit workflow
        </Button>
      </CardContent>
    </Card>
  );
}
